import { organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { getAppBaseUrl } from "@/lib/shared/deployment";

const getBaseURL = () => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  return getAppBaseUrl();
};

export const authClient: ReturnType<typeof createAuthClient> = createAuthClient(
  {
    baseURL: getBaseURL(),
    plugins: [organizationClient()],
  },
);

// Export hooks for use in components
export const { useSession } = authClient;

export type StartMazricaLoginOptions = {
  errorCallbackURL?: string;
};

/**
 * Starts the Mazrica ID sign-in and returns the authorization URL to navigate
 * to, or null when BetterAuth has already taken care of the navigation.
 */
export async function startMazricaLogin(
  callbackURL: string,
  options?: StartMazricaLoginOptions,
): Promise<string | null> {
  const result = await authClient.signIn.social({
    provider: "mazrica-id",
    callbackURL,
    ...(options?.errorCallbackURL
      ? { errorCallbackURL: options.errorCallbackURL }
      : {}),
  });
  if (result.error) {
    throw new Error("Mazrica ID login could not be started");
  }

  const data = result.data as
    | { redirect?: unknown; url?: unknown }
    | null
    | undefined;
  if (data?.redirect !== true || typeof data.url !== "string") {
    return null;
  }

  const url = new URL(data.url, window.location.href);
  return url.protocol === "http:" || url.protocol === "https:"
    ? url.href
    : null;
}
